import React, { useRef, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { useStoreCoachAi } from "../../stores/useStoreCoachAi";
import { isEmptyObject } from "../../utils/GenericFn";
import Image from "../Tags/Image";
import Text from "../Tags/Text";
import ScorecardsContent from "./shared/ScorecardsContent";

export default function Reports() {
  const transcriptContainerRef = useRef(null);
  const { reportData, transcript } = useStoreCoachAi();
  const [historyTab, setHistoryTab] = useState("scorecards");

  console.log("reportData", reportData);

  const tabs = [
    {
      name: "Scorecards",
      key: "scorecards",
    },
    // {
    //   name: "Summary",
    //   key: "summary",
    // },
    {
      name: "Transcript",
      key: "transcript",
    },

    // {
    //   name: "Evaluation",
    //   key: "evaluation",
    // },
  ];

  const getSpeakerLabel = (role) => {
    if (role === "client") return "You";
    if (role === "server") return "CoachAI";
    return "";
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "";

    try {
      return new Date(timestamp).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch (err) {
      console.error("Failed to format timestamp", err);
      return "";
    }
  };

  if (isEmptyObject(reportData)) {
    return <div></div>;
  }

  return (
    <Tabs
      defaultValue={historyTab}
      value={historyTab}
      onValueChange={(value) => {
        setHistoryTab(value);
      }}
      className="w-full"
    >
      <TabsList className="border-border border-t-0 bg-none border-b w-full rounded-none p-0 px-2 pt-2 space-x-6">
        {/* <TabsTrigger value="scorecards">Scorecards</TabsTrigger>
        <TabsTrigger value="transcript">Transcript</TabsTrigger> */}

        {/* <TabsTrigger value="evaluation">Evaluation</TabsTrigger>
                     <TabsTrigger value="summary">Summary</TabsTrigger> */}

        {tabs &&
          tabs.length > 0 &&
          tabs.map((el) => (
            <Button
              className={`font-semibold hover:bg-none py-3 h-auto mobile:w-6/12 mobile:ml-0 text-text-500 focus:bg-none px-1 rounded-none border-t-0 border-x-0 shadow-none ${
                el.key === historyTab
                  ? "bg-transparent text-brand-700 pointer-events-none border-b-2 border-brand-600"
                  : "border-b-2 border-transparent bg-none"
              }`}
              variant={el.key === historyTab ? "purple-outline" : "ghost-no-hover"}
              onClick={(e) => {
                setHistoryTab(el.key);
              }}
            >
              {el.name}
            </Button>
          ))}
      </TabsList>
      <TabsContent value="summary" className="w-full">
        <div className="flex justify-center items-center flex-col space-y-3 mt-16">
          <Image src="/images/coming-soon.svg" />
          <Text size="md">Coming soon...</Text>
        </div>
      </TabsContent>
      <TabsContent value="transcript" className="w-full">
        {/* <div className="flex justify-center items-center flex-col space-y-3 mt-16">
          <Image src="/images/coming-soon.svg" />
          <Text size="md">Coming soon...</Text>
        </div> */}
        <div className="p-4">
          <div>
            {!transcript ? (
              <div className="flex justify-center items-center flex-col space-y-3 mt-16">
                <Image src="/images/coming-soon.svg" />
                <Text size="md">No transcription is available for this session.</Text>
              </div>
            ) : (
              <div className="bg-gray-100 rounded-md p-4">
                <div
                  ref={transcriptContainerRef}
                  className="chat__box__area space-y-4 max-h-[500px] overflow-y-auto"
                >
                  {transcript &&
                    transcript.length > 0 &&
                    transcript.map((entry) => (
                      <div
                        key={`${entry.role}-${entry.timestamp}-${entry.text}`}
                        className={entry.role === "client" ? "flex justify-end" : "flex"}
                      >
                        <div className="max-w-[70%]">
                          <div className="text-xs mb-1 text-gray-500">{getSpeakerLabel(entry.role)}</div>
                          <div className="bg-background border border-border p-3 rounded-md inline-block whitespace-pre-line">
                            {entry.text}
                          </div>
                          <div
                            className={`text-[10px] text-gray-400 mt-1 ${
                              entry.role === "client" ? "text-right" : "text-left"
                            }`}
                          >
                            {formatTimestamp(entry.timestamp)}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </TabsContent>
      <TabsContent value="scorecards" className="w-full">
        <div className="p-6 overflow-y-scroll" style={{ height: "calc(100vh - 150px)" }}>
          <ScorecardsContent reportData={reportData} />
        </div>
      </TabsContent>
      <TabsContent value="evaluation" className="w-full">
        <div className="flex justify-center items-center flex-col space-y-3 mt-16">
          <Image src="/images/coming-soon.svg" />
          <Text size="md">Coming soon...</Text>
        </div>
      </TabsContent>
    </Tabs>
  );
}
